import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const createRedeemOrder = async (postData:any) => {
    try{
  return await post<ApiResponse<[]>>('/redeem/reward/order', postData).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){

}
};
